var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['threedimension', {isscroly: _vm.slideIndex !== undefined}]},[_c('canvas',{attrs:{"touch-action":"none"}}),(_vm.showLoading)?_c('st-loading',{attrs:{"themecolor":_vm.slideIndex === undefined ? '' : 'darkcolor'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }